import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Route, Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as CreDtos from "../../CRE.dtos";
import { publishedData } from '../../data';
import { bindActionCreators } from "redux";
import { PublicationGroup } from './PublicationGroup';

interface IPublicationsProps {
    publications: CreDtos.Publication[];
    focus: CreDtos.Focus[];
    publicationTypes: CreDtos.PublicationType[];
    isLoading: boolean;
    location: any;
}

class Publications extends React.Component<IPublicationsProps, any> {
    constructor(props: IPublicationsProps) {
        super(props);
        this.state = {
            focusFilter: []
        };
        this.onFocusFilterClicked = this.onFocusFilterClicked.bind(this);
    }

    componentDidMount() {
        this.loadSiteData();

        const anchor = this.props.location ? this.props.location.hash.replace('#', '') : undefined;

        

        if (anchor) {
            const domElement = ReactDOM.findDOMNode(this.refs[anchor]);
            if (domElement) {
                domElement.scrollIntoView();
            }
        } else {
            window.scrollTo(0, 0);
        }
    }

    componentDidUpdate(preProps) {
        if (!this.props.isLoading && preProps.isLoading) {
            this.loadSiteData();
        }
    }

    loadSiteData() {
        let focusFilter = [];
        if (this.props.focus) {
            this.props.focus.filter(f => f.enabled).forEach(f => {
                focusFilter.push(f.focusName.toLowerCase());
            });
        }

        this.setState({ focusFilter });
    }

    onFocusFilterClicked(focusType) {
        let focusFilter = [];
        let idx = this.state.focusFilter.indexOf(focusType);
        if (idx < 0 || this.state.focusFilter.length == 6) {
            focusFilter.push(focusType);
        } else {
            if (this.props.focus) {
                this.props.focus.filter(f => f.enabled).forEach(f => {
                    focusFilter.push(f.focusName.toLowerCase());
                });
            }
        }
        this.setState({ focusFilter: focusFilter });

    }

    filterCss(filter) {
        let activeToggle = "btn-publication";
        let inactiveToggle = "btn-publication grey-bg";
        let filterFullHouse = this.state.focusFilter.length == 6;
        return filterFullHouse || this.state.focusFilter.indexOf(filter) >= 0 ? activeToggle : inactiveToggle;
    }

    render() {

        if (!this.props.publications || this.props.isLoading) {
            return (<div></div>);
        }

        let focusFilter = this.state.focusFilter;
        let filteredData = this.props.publications.filter(function (i, n) {
            //return true;
            return i.focus.find(function (item) { return focusFilter.indexOf(item.toLowerCase()) > -1 });
        });

        let preventCss = this.filterCss("prevent");
        let treatCss = this.filterCss("treat");
        let cpCss = this.filterCss("community programs");
        let rhCss = this.filterCss("reduce harms");
        let rtCss = this.filterCss("research tools");
        let policyCss = this.filterCss("policy");

        return (<div id="SectionContainer" >
            <section className="content page-content" style={{paddingBottom: "200px"}} >
                <div className="container">
                    <h1>Publications</h1>
                    <div className="row mt-0 mt-md-3">
                        <div className="col-12 col-md-3">
                            <div className="row">
                                <div className="col-12 publication-filters btn-group-vertical">
                                    <strong>&nbsp;</strong>
                                </div>
                                <div className="col-12 mt-1">
                                    <div className="publication-filters btn-group-vertical btn-block" role="group">
                                        <button onClick={this.onFocusFilterClicked.bind(this, 'prevent')} type="button" className={`btn ${preventCss}`}  >PREVENT</button>
                                        <button onClick={this.onFocusFilterClicked.bind(this, 'treat')} type="button" className={`btn ${treatCss}`}  >TREAT</button>
                                        <button onClick={this.onFocusFilterClicked.bind(this, 'community programs')} type="button" className={`btn ${cpCss}`}  >COMMUNITY PROGRAMS</button>
                                        <button onClick={this.onFocusFilterClicked.bind(this, 'reduce harms')} type="button" className={`btn ${rhCss}`}  >REDUCE HARMS</button>
                                        <button onClick={this.onFocusFilterClicked.bind(this, 'research tools')} type="button" className={`btn ${rtCss}`}  >RESEARCH TOOLS</button>
                                        <button onClick={this.onFocusFilterClicked.bind(this, 'policy')} type="button" className={`btn ${policyCss}`}  >POLICY</button>
                                    </div>

                                    <div className="publication-filters row mb-3">
                                        <button onClick={this.onFocusFilterClicked.bind(this, 'prevent')} type="button" className={`btn col-6 ${preventCss}`} style={{ border: "solid 2px white" }}>PREVENT</button>
                                        <button onClick={this.onFocusFilterClicked.bind(this, 'treat')} type="button" className={`btn col-6 ${treatCss}`} style={{ border: "solid 2px white" }} >TREAT</button>
                                        <button onClick={this.onFocusFilterClicked.bind(this, 'community programs')} type="button" className={`btn col-6 ${cpCss}`} style={{ border: "solid 2px white" }} >COMMUNITY PROGRAMS</button>
                                        <button onClick={this.onFocusFilterClicked.bind(this, 'reduce harms')} type="button" className={`btn col-6 ${rhCss}`} style={{ border: "solid 2px white" }} >REDUCE HARMS</button>
                                        <button onClick={this.onFocusFilterClicked.bind(this, 'research tools')} type="button" className={`btn col-6 ${rtCss}`} style={{ border: "solid 2px white" }} >RESEARCH TOOLS</button>
                                        <button onClick={this.onFocusFilterClicked.bind(this, 'policy')} type="button" className={`btn col-6 ${policyCss}`} style={{ border: "solid 2px white" }} >POLICY</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-9 ">
                            <div className="row mb-1">
                                <div className="col-4 col-md-6">
                                    <strong>TITLE</strong>
                                </div>
                                <div className="col-5 col-md-4">
                                    <strong>PUBLISHED BY</strong>
                                </div>
                                <div className="col-2 col-md-1">
                                    <strong>YEAR</strong>
                                </div>
                                <div className="col-1 col-md-1">
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 publication-table">
                                    {this.props.publicationTypes.map((item, index) => (
                                        <div>
                                            <a id={item.publicationTypeName} className="anchor" />
                                            <PublicationGroup groupTypeId={item.id} groupType={item.publicationTypeName} data={filteredData} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
        </div>
        );
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        publications: state.siteData.siteData.publications,
        focus: state.siteData.siteData.focus,
        publicationTypes: state.siteData.siteData.publicationTypes,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {},
        dispatch
    );
};


const PublicationsContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(
    Publications
));

export default PublicationsContainer;



// WEBPACK FOOTER //
// ./src/components/Publications/Publications.tsx